import bookkeepingInvoiceApi from '../../../../../api/bookkeeping/bookkeepingInvoiceApi.js';
import action from '../../../abstract/action.js';

export default action({
  main: () => true,
  label: 'Drukuj',
  icon: 'PrinterIcon',
  handle: ({ $vs, item: { id } }) => {
    $vs.loading();

    bookkeepingInvoiceApi.printData({ invoiceId: id })
      .then(({ data: { url } }) => {
        const link = document.createElement('a');
        link.download = 'download';
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .finally(() => {
        $vs.loading.close();
      });
  },
});
